import { mergeClasses } from '@fluentui/react-components';
import styles from './StrengthIndicator.module.scss';
import IPasswordStrengthIndicatorProps from './IPasswordStrengthIndicatorProps';
import { useEffect, useState } from 'react';
import Strength from './Strength';
import { useTranslation } from 'react-i18next';

const PasswordStrengthIndicator = (props: IPasswordStrengthIndicatorProps) => {
  const { t } = useTranslation();

  const [strength, setStrength] = useState<number>(0);
  useEffect(() => {
    Strength(props.password)
      .then(result => setStrength(result.score))
      .catch(() => setStrength(0));
  }, [props.password]);

  const value = (strength + 1) * 20;
  const variant = strength < 2 
    ? 'danger'
    : strength < 4
      ? 'warning'
      : 'success';
    
  const label = strength < 2
    ? t("passwords.strength.weak")
    : strength < 4
      ? t("passwords.strength.moderate")
      : t("passwords.strength.strong");

  const fillStyle = mergeClasses(styles["progress-fill"], styles[variant]);
    
  return (
    <div className={styles["custom-progress-bar"]}>
      <div className={fillStyle} style={{ width: `${value}%` }}>
        {label}
      </div>
    </div>
  );
};

export default PasswordStrengthIndicator;